import React, {useEffect, useState} from 'react';
import {IMacroSpessore} from "../../../../../../../utils/interfaces/tannery_production/articles/IMacroSpessore";
import {useToast} from "../../../../../../../utils/contexts/toast-context";
import {useAuth} from "../../../../../../../utils/contexts/auth-context";
import {useTheme} from "@mui/material/styles";
import {useTranslation} from "react-i18next";
import useApiGetMacroSpessori from "./api-hooks/useApiGetMacroSpessori";
import {CustomAxiosError} from "../../../../../../../logics/api_config";
import Loading from "../../../../../../ui/Loading";
import {Box} from "@mui/material";
import MuiAutocomplete from "../../../../../../ui/mui/mui-input/MuiAutoComplete";
import TextField from "@mui/material/TextField";


interface MacroSpessoriSelectProps {
    spessore: IMacroSpessore | undefined,
    onChange: (spessore: IMacroSpessore | null) => void,
    label?: string,
    required?: boolean
}

const MacroSpessoriSelect = ({spessore: initialObj, onChange, label, required}: MacroSpessoriSelectProps) => {
    const {displayError, displayMessage} = useToast()
    const {selectedCompany} = useAuth()

    const theme = useTheme();
    const {t} = useTranslation();

    const [objs, setObjs] = useState<IMacroSpessore[]>([]);
    const [obj, setObj] = useState<IMacroSpessore | null | undefined>(initialObj);

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [isEditFormOpen, setIsEditFormOpen] = useState<boolean>(false)

    const {
        data,
        isLoading,
        error,
    } = useApiGetMacroSpessori(selectedCompany?.company_token);
    if (error) {
        const axiosError = error as CustomAxiosError;
        displayError(axiosError.response.data.detail);
    }


    useEffect(() => {
        setObj(initialObj);
    }, [initialObj]);

    useEffect(() => {
        if (data) {
            setObjs(data);
        }
    }, [data]);

    const handleOnChange = (event: React.SyntheticEvent, newValue: IMacroSpessore | null) => {
        setObj(newValue);
        onChange(newValue);
    };


    return (
        isLoading ? (
            <Loading/>
        ) : (
            <>
                <Box sx={{alignItems: 'center', width: '100%'}}>
                    <MuiAutocomplete
                        id="macro_spessori-select"
                        options={objs}
                        getOptionLabel={(option: any) => option.spessore_name}
                        value={obj ? obj : null}
                        onChange={handleOnChange}
                        isOptionEqualToValue={(option: any, value: any) => option.id === value?.id && option.spessore_name === value?.spessore_name}
                        renderInput={(params: any) => (
                            <TextField
                                sx={{textTransform: 'capitalize'}}
                                {...params}
                                label={label || t('macro_spessore')}
                                required={required}
                            />
                        )}
                    />
                </Box>
            </>
        )
    );
}

export default MacroSpessoriSelect;